<template>
    <div>
        <div id="TianYuanBannerPage">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide>
                    <TianYuanFirst :obj="data"></TianYuanFirst>
                </swiper-slide>
                <swiper-slide>
                    <TianYuanSecond :obj="data"></TianYuanSecond>
                </swiper-slide>
                <swiper-slide>
                    <TianYuanhree :obj="data"></TianYuanhree>
                </swiper-slide>
                <swiper-slide>
                    <TianYuanFourth :obj="data"></TianYuanFourth>
                </swiper-slide>
                <swiper-slide>
                    <TianYuanFifth :obj="data"></TianYuanFifth>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <div class="mouse_bigbox">
                <div class="mouse_box">
                    <div class="dian"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TianYuanFirst from "../../components/TianYuanHome/first";
    import TianYuanSecond from "../../components/TianYuanHome/second";
    import TianYuanhree from "../../components/TianYuanHome/three";
    import TianYuanFourth from "../../components/TianYuanHome/fourth";
    import TianYuanFifth from "../../components/TianYuanHome/fifth";
    import {
        getConduitInfo
    } from "../../http/api";
    export default {
        name: "",
        props: {},
        components: {
            TianYuanFirst,
            TianYuanSecond,
            TianYuanhree,
            TianYuanFourth,
            TianYuanFifth,
        },
        data() {
            var that = this;
            return {
                swiperOption: {
                    slidesPerView: 1,
                    mousewheel: true,
                    direction: "vertical",
                    autoHeight: true,
                    height: window.innerHeight,
                    speed: 800,
                    simulateTouch: false,
                    pagination: {
                        //分页容器的css选择器
                        el: ".swiper-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            var text = "";
                            console.log(index);
                            switch (index) {
                                case 0:
                                    text = "ONE";
                                    break;
                                case 1:
                                    text = "TWO";
                                    break;
                                case 2:
                                    text = "THREE";
                                    break;
                                case 3:
                                    text = "FOUR";
                                    break;
                                case 4:
                                    text = "FIVE";
                                    break;
                            }
                            return (
                                '<li class=" ' +
                                className +
                                '">' +
                                `<span class="swiperspan"> ${text}</span><span class="top">▲</span><span class="dian"></span><span class="bottom">▼</span>` +
                                "</li>"
                            );
                        },
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    on: {
                        slideChangeTransitionStart: function() {
                            if (this.activeIndex === 1) {
                                that.$store.state.logoFlag = true;
                            } else {
                                that.$store.state.logoFlag = false;
                            }
                        },
                    },
                },
                data: {},
            };
        },
        methods: {
            tianyuanData(id) {
                getConduitInfo({
                    id: id
                }).then((res) => {
                    this.data = res.data;
                });
            },
        },
        computed: {
            setlogoFlag() {
                return this.$store.state.logoFlag;
            },
        },
        watch: {
            setlogoFlag(val) {
                console.log(val);
            },
        },
        mounted() {
            this.tianyuanData(this.$route.query.id);
        },
    };
</script>

<style scoped lang='scss'>
    #TianYuanBannerPage {
        width: 100%;
        min-width: 1200px;

        .mouse_bigbox {
            width: 100vw;
            position: fixed;
            bottom: 4vh;
            z-index: 99;
            display: flex;
            justify-content: center;

            .mouse_box {
                width: 22px;
                height: 3vh;
                background-image: url("../../assets/components_img/mouse.png");
                background-size: 100% 100%;
                display: flex;
                justify-content: center;
                z-index: 99;

                .dian {
                    width: 3px;
                    height: 6px;
                    margin-top: 6px;
                    background: #ffffff;
                    border-radius: 1px;
                    animation: myfirstjt 1s linear infinite;
                }

                @keyframes myfirstjt {
                    0% {
                        transform: translateY(0px);
                    }

                    50% {
                        transform: translateY(4px);
                    }

                    100% {
                        transform: translateY(0px);
                    }
                }
            }
        }
    }
</style>
